var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClipBadge4K = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 23,
  height: 17,
  viewBox: "0 0 23 7"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-1-1h24v9H-1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M9.813 0v4.4h1.3v1.2h-1.3v.9h-2.6v-1h-6.5c-1.1 0-.6-1.1-.6-1.1s5.9-4.3 6.1-4.4zm-2.6 1.5-3.8 2.6h3.8zm4.3-1.5v6.5h2.7V3.8l4.3 2.7h3.6l-5.7-3.5 5.3-3h-3.4l-4.1 2.4V0z"
}))));
export default SvgClipBadge4K;